/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionStats } from './CompetitionStats';
import {
    CompetitionStatsFromJSON,
    CompetitionStatsFromJSONTyped,
    CompetitionStatsToJSON,
    CompetitionStatsToJSONTyped,
} from './CompetitionStats';

/**
 * Response containing aggregated competition statistics
 * @export
 * @interface CompetitionStatsResponse
 */
export interface CompetitionStatsResponse {
    /**
     * 
     * @type {CompetitionStats}
     * @memberof CompetitionStatsResponse
     */
    stats?: CompetitionStats;
}

/**
 * Check if a given object implements the CompetitionStatsResponse interface.
 */
export function instanceOfCompetitionStatsResponse(value: object): value is CompetitionStatsResponse {
    return true;
}

export function CompetitionStatsResponseFromJSON(json: any): CompetitionStatsResponse {
    return CompetitionStatsResponseFromJSONTyped(json, false);
}

export function CompetitionStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'stats': json['stats'] == null ? undefined : CompetitionStatsFromJSON(json['stats']),
    };
}

export function CompetitionStatsResponseToJSON(json: any): CompetitionStatsResponse {
    return CompetitionStatsResponseToJSONTyped(json, false);
}

export function CompetitionStatsResponseToJSONTyped(value?: CompetitionStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stats': CompetitionStatsToJSON(value['stats']),
    };
}

